import React from "react";
import type { ModuleOptions } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { AttributeTabs } from "src/admin/modules/attribute/constants.ts";
import { type AttributeResource, AttrTypes } from "@exonn/js-sdk";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const module: ModuleOptions<AttributeResource> = {
  resource: ResourceEnum.Attribute,
  smallIcon: <i className="icon-15-accounting_adm" />,
  bigIcon: <i className="icon-20-accounting_adm" />,
  layoutForm: true,

  formTabs: {
    [AttributeTabs.General]: {
      title: (t) => t("formTabs.general"),
    },
    [AttributeTabs.AttributeValues]: {
      title: (t) => t("formTabs.attribute_value"),
      isDisabled: ({ data: attribute }) => {
        if (!attribute) {
          return false;
        }
        return attribute.attribute_type !== AttrTypes.SELECTION_LIST;
      },
      isHidden: ({ values }) => {
        return values.attribute_type !== AttrTypes.SELECTION_LIST;
      },
      disabledTooltip: ({ t }) => {
        return t("disabledFunctionality", {
          ns: TranslationNamespaceEnum.FormComponent,
        });
      },
      routeObject: {
        lazy: () =>
          import(
            "src/admin/modules/attribute/routes/edit/tabs/attribute-values/attribute-values.tsx"
          ),
      },
    },
  },
};
